import siteMessage from "@insite/client-framework/SiteMessage";

const accountShippingTerm = (value: string) => {
    if(value.toLowerCase()==="x"){
        return siteMessage("shippingTerm_prepaid");
    }
    if(value.toLowerCase()==="n"){
        return siteMessage("shippingTerm_ThirdParty");
    }
    if(value.toLowerCase()==="col"){
        return siteMessage("shippingTerm_Collect");
    } 
    return siteMessage("shippingTerm_prepaid");
}

export default accountShippingTerm;
